import React, { useContext, useEffect, useState } from 'react'
import { Box, Card, CardContent, Paper, Typography, useTheme } from '@mui/material'
import CheckoutForm from './CheckoutForm'
import { CheckoutElementsProvider } from '@stripe/react-stripe-js/checkout'
import { ReservationContext } from '../../context/ReservationContext'
import { formatDate } from '../../utils/date'
import useMediaQuery from '@mui/material/useMediaQuery'
import { displaySeatIds } from '../../utils/display'
import { GoogleLocation } from '../GoogleLocation'
import { useLocation } from 'react-router-dom'

export function Booking() {
  const theme = useTheme()
  const [clientSecret, setClientSecret] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const {
    stripePromise,
    getClientSecret,
    shows,
    showId,
    scheduleId,
    totalTickets,
    totalPrice,
    selectedSeats,
    firstName,
    lastName,
    phone,
    email
  } = useContext(ReservationContext)
  const appearance = {
    theme: 'stripe'
  }
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')) // xs‑sm
  const selectedShow = shows.find((show) => show.id === showId)
  const selectedSchedule = selectedShow ? selectedShow.schedules.find((shed) => shed.id === scheduleId) : null
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.includes('/retry')) {
      window.history.replaceState(null, '', '/')
    }
  }, [])
  useEffect(() => {
    if (showId === -1) return
    const cSecret = getClientSecret(setErrorMessage)
    setClientSecret(cSecret)
  }, [showId, scheduleId, totalTickets, totalPrice, selectedSeats, firstName, lastName, phone, email, getClientSecret])

  return (
    <Paper
      elevation={3}
      sx={{
        minHeight: '400px',
        maxHeight: { xs: '50vh', sm: '60vh' },
        overflowY: 'auto',
        p: { xs: 1, sm: 2 },
        borderRadius: 10
      }}
    >
      <Typography variant='h5' sx={{ mb: 1, fontWeight: 'bold', color: 'title.main' }}>
        5. Paiement
      </Typography>

      {errorMessage ? (
        <p>{errorMessage}</p>
      ) : (
        <Box>
          {clientSecret && (
            <CheckoutElementsProvider
              stripe={stripePromise}
              options={{
                clientSecret,
                elementsOptions: { appearance }
              }}
            >
              <Box sx={{ p: 4, maxWidth: 800, mx: 'auto' }}>
                <Card variant='outlined' sx={{ width: '80%', mx: 'auto' }}>
                  <CardContent sx={{ textAlign: 'left' }}>
                    <Typography variant='h6' sx={{ textAlign: 'center' }}>
                      Résumé de votre commande:
                    </Typography>
                    <Typography gutterBottom sx={{ color: 'title.main', fontSize: 24 }}>
                      {selectedShow.title}
                    </Typography>
                    <Typography>
                      <GoogleLocation show={selectedShow} />
                    </Typography>
                    <Typography sx={{ mb: 1, ml: 5 }}>
                      Le {formatDate(selectedSchedule.date, isSmallScreen)} à {selectedSchedule.time}
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                      Au nom de: {firstName} {lastName} - Tél: {phone} - Email: {email}
                    </Typography>
                    <Typography sx={{ color: 'secondary.main' }}>
                      {totalTickets} places ({displaySeatIds(selectedSeats)}) pour un total de {totalPrice / 100} €
                    </Typography>
                  </CardContent>
                </Card>
                <CheckoutForm />
              </Box>
            </CheckoutElementsProvider>
          )}
        </Box>
      )}
    </Paper>
  )
}
